export const notConnected = 'notConnected'
export const connectedNotClaimed = 'connectedNotClaimed'
export const accepted = 'accepted'
export const notEligible = 'notEligible'
export const videoPending = 'videoPending'
export const videoApprovedCreator = 'videoApprovedCreator'
export const videoApprovedNotCreator = 'videoApprovedNotCreator'
export const creatorRejectedStatus = 'creatorRejectedStatus'
export const pending = 'pending'
